// Resolves an in-app path to either a relative SPA link (when the home
// components render inside the SPA build) or an absolute URL pointing at the
// app subdomain (when they render in the standalone landing build served from
// a different origin).
//
// Driven by VITE_APP_URL: empty/unset → return the path verbatim; otherwise
// prepend the origin (with any trailing slash stripped). Anchor and absolute
// hrefs pass through unchanged so footer links to GitHub or `#concept` aren't
// mangled.

const RAW_BASE = (import.meta.env.VITE_APP_URL ?? "").trim();
const APP_BASE = RAW_BASE.replace(/\/$/, "");

export function appHref(path: string): string {
  if (!path) return path;
  if (path.startsWith("#")) return path;
  if (/^[a-z][a-z0-9+.-]*:/i.test(path)) return path;
  if (!APP_BASE) return path;
  return APP_BASE + (path.startsWith("/") ? path : `/${path}`);
}
